import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import { CenteredCustomTypography } from '../custom-material/typography/Typography'
import CustomButton, { CancelCustomButton, OkDialogButton } from '../custom-material/button/Button'
import _ from 'lodash'

const styles = theme => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 32px'
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '50%'
  }
})

class AddUsersDialogComponent extends React.PureComponent {
  _confirmationMessage (authorizationContacts) {
    if (!_.isEmpty(authorizationContacts)) {
      return (
        <React.Fragment>
          <CenteredCustomTypography variant='body1' paragraph>Please note your request must be authorized by</CenteredCustomTypography>
          {authorizationContacts.map((x, i) => <CenteredCustomTypography key={i} variant='body1'>{x.firstName} {x.lastName}</CenteredCustomTypography>)}
          <CenteredCustomTypography variant='body1' paragraph>IPD will reach out to get authorization. Once it is received, you will be sent an email confirmation.</CenteredCustomTypography>
        </React.Fragment>
      )
    } else {
      return (
        <CenteredCustomTypography variant='body1' paragraph>The user(s) will receive an email within 24 business hours with product information and <strong>activation instructions</strong>.</CenteredCustomTypography>
      )
    }
  }

  _headerMessage (isBulkAdd, contactsToAdd, isConfirmed) {
    if (isConfirmed && !isBulkAdd) {
      return <span>You have successfully requested to <strong>add the following User(s)</strong> to your IPD Analytics Subscription:</span>
    }
    if (isConfirmed && isBulkAdd) {
      return <span>You have successfully requested to <strong>add <em>{`${contactsToAdd.length}`}</em> User(s)</strong> to your IPD Analytics Subscription.</span>
    }
    if (!isConfirmed && !isBulkAdd) {
      return <span>Please confirm you would like to request to <strong>add the following User(s)</strong> to your IPD Analytics Subscription:</span>
    }
    if (!isConfirmed && isBulkAdd) {
      return <span>Please confirm you would like to request to <strong>add <em>{`${contactsToAdd.length}`}</em> User(s)</strong> to your IPD Analytics Subscription.</span>
    }
  }

  render () {
    const { classes, dialogOpen, contactsToAdd, handleCloseDialog, handleConfirmDialog, addContacts, authorizationContacts, isBulkAdd } = this.props
    const isConfirmed = dialogOpen === 'confirm'

    return (
      <CustomDialog open={!!dialogOpen} onClose={handleCloseDialog} aria-labelledby='updates-dialog-title'>
        <CustomDialogTitle id='updates-dialog-title' disableTypography>Request to Add User</CustomDialogTitle>
        <div className={classes.contentContainer}>
          <CenteredCustomTypography variant='body1' paragraph>
            {this._headerMessage(isBulkAdd, contactsToAdd, isConfirmed)}
          </CenteredCustomTypography>
          {!isBulkAdd && contactsToAdd.map((x, i) => <CenteredCustomTypography key={i} variant='body1'>{x.firstName} {x.lastName}</CenteredCustomTypography>)}<br />
          {isConfirmed
            ? this._confirmationMessage(authorizationContacts)
            : <CenteredCustomTypography variant='body1' paragraph>Do you want to continue?</CenteredCustomTypography>}
          <br />
          <div className={classes.actionContainer}>
            {isConfirmed
              ? <OkDialogButton variant='contained' size='small' color='secondary' onClick={handleConfirmDialog} style={{marginRight: '-55%'}}>OK</OkDialogButton>
              : <React.Fragment>
                <CancelCustomButton variant='contained' size='small' color='default' onClick={handleCloseDialog}>Cancel</CancelCustomButton>
                <CustomButton variant='contained' size='small' color='secondary' onClick={addContacts}>Yes</CustomButton>
              </React.Fragment>
            }
          </div>
        </div>
      </CustomDialog>
    )
  }
}

AddUsersDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.oneOf([true, false, 'confirm']),
  contactsToAdd: PropTypes.array,
  handleCloseDialog: PropTypes.func,
  handleConfirmDialog: PropTypes.func,
  addContacts: PropTypes.func,
  authorizationContacts: PropTypes.array,
  isBulkAdd: PropTypes.bool
}

export default withStyles(styles)(AddUsersDialogComponent)
